export default "__VITE_ASSET__DvoA2mue__"